import { createSelector } from 'reselect';

import getOrderTotals from './getOrderTotals';
import moment, { Moment } from 'moment-timezone';

import { SALE_TYPE } from '../constants/saleType';

export type DetermineEarliestFutureOrderingDateTime = {
  totals?: OrderTotals;
  saleType: SALE_TYPE;
  location?: POSLocation;
};

export const determineEarliestFutureOrderingDateTime = ({
  totals,
  saleType,
  location,
}: DetermineEarliestFutureOrderingDateTime): Moment => {
  const cutOffTimes: CutoffTime[] = location?.cutoffTresholds || [];

  const filteredCutoffTimes = cutOffTimes?.filter(
    cutOffTimes =>
      cutOffTimes.SaleType === saleType &&
      totals?.moneyPrice !== undefined &&
      cutOffTimes.MoneyLower <= totals.moneyPrice,
  );

  const timeRequiredInAdvance = (filteredCutoffTimes ?? []).reduce((a, b) => {
    return a + b.Time;
  }, 0);

  const tomorrowNow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  const earliestCateringOrderTime = moment(tomorrowNow)
    .add(timeRequiredInAdvance, 'hours')
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

  return earliestCateringOrderTime;
};

export default ({
  saleType,
  location,
}: {
  saleType: SALE_TYPE;
  location?: POSLocation;
}) =>
  createSelector([getOrderTotals], totals =>
    determineEarliestFutureOrderingDateTime({
      totals,
      saleType,
      location,
    }),
  );
